import { Capacitor } from '@capacitor/core';
import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';
import { captureException } from '@sentry/react';
import { defineCustomElements as jeepSqlite } from 'jeep-sqlite/loader';

class SqliteConnector {
  private connectionPromise: Promise<SQLiteConnection> | undefined = undefined;

  async connect() {
    if (!this.connectionPromise) {
      this.connectionPromise = this.resolveConnection().catch((e) => {
        console.error(e);

        captureException(e, {
          level: 'error',
          extra: { message: 'Failed to initialize SQLite' },
        });

        throw e;
      });
    }

    return this.connectionPromise;
  }

  private async resolveConnection() {
    const sqlite = new SQLiteConnection(CapacitorSQLite);

    if (!Capacitor.isNativePlatform()) {
      jeepSqlite(window);

      const jeepEl = document.createElement('jeep-sqlite');
      document.body.appendChild(jeepEl);
      await customElements.whenDefined('jeep-sqlite');

      await sqlite.initWebStore();
    }

    return sqlite;
  }
}

export const sqliteConnector = new SqliteConnector();
